import { AdminFormComponent } from "Components/Shared";

const AddAdmin = () => {
  return <AdminFormComponent isEditAdmin={false} />;
};

export default AddAdmin;
